export function formatNumberFilter() {

    return (input: string) => {

        var inputNumber = Number(input);

        if (inputNumber > 1000) {
            var thousands = inputNumber / 1000;
            thousands = Math.round(thousands * 10) / 10;
            return `${thousands}k`;
        }

        return input;
    }
}
